import { useQuery } from "react-query";
import { useParams } from "react-router-dom";

import http from "../../services/httpService";
import Util from "../../util/util";
import useUrls from "../useUrls";

const getLeague = (leagueUrl, apiUrl) => async () => {
  console.log("getLeague() called...");

  const config = Util.addTokenToHeaders();
  const { data } = await http.get(`${apiUrl}/leagues/${leagueUrl}`, config);

  console.log(`getLeague(${leagueUrl}) response data:`);
  console.log(data);

  return data;
};

/**
 *
 * @returns {UseQueryResult<*, unknown>}
 */
export default function useQueryLeague() {
  let { league: leagueUrl } = useParams();
  const { apiUrl } = useUrls();

  return useQuery(["leagues", leagueUrl], getLeague(leagueUrl, apiUrl), {
    enabled: !!leagueUrl,
    refetchOnWindowFocus: false,
    staleTime: 4 * 60 * 60 * 1000,
  });
}
